import type { ReactNode } from 'react'
import ShipmentCalculatedValue from '../../../components/shipment-calculated-value/shipment-calculated-value'
import {
    getShipmentDisplayCalculated,
    isShipmentCalculatedOnActual,
} from '../../../helpers/entities/shipment/get-shipment-display-calculated'
import Calculated from '../../../types/api/components/calculation-position/calculated'
import Shipment from '../../../types/api/shipment'
import { renderShipment } from './helpers'

export const renderShipmentCalculated = (
    render: (calculated: Calculated | undefined, shipment: Shipment) => ReactNode
) =>
    renderShipment(shipment => (
        <ShipmentCalculatedValue isActual={isShipmentCalculatedOnActual(shipment)}>
            {render(getShipmentDisplayCalculated(shipment), shipment)}
        </ShipmentCalculatedValue>
    ))
